import React from 'react';
import useLocationSearchParams from '@medflex/hooks/useLocationSearchParams';
import { TRACKING_ACTIONS, trackEvent } from '@medflex/utils/Tracking';
import useModal from '../../hooks/useModal';
import PermanentQRCode from './PermanentQRCode';
import PermanentQRCodePrintFlyer from './PermanentQRCodePrintFlyer';

const PatientPermanentQRCodeModule = () => {
  const { close } = useModal();
  const searchParams = useLocationSearchParams();
  const isQRFlyerPrint = searchParams.action === 'print';

  const handleClose = () => {
    trackEvent({
      zone: 'PatientPermanentQRCode',
      actionText: TRACKING_ACTIONS.CLOSE,
    });
    close({ modal: 'patientPermanentQRCode', action: '' });
  };

  if (isQRFlyerPrint) return <PermanentQRCodePrintFlyer onClose={handleClose} />;
  return <PermanentQRCode onClose={handleClose} />;
};

export default PatientPermanentQRCodeModule;
